export const Spinner = () => {
	return (
		<div className="spinner-relative">
			<div className="spinner-absolute">
				<div className="loadingio-spinner">
					<div className="spinner">
						<div></div>
					</div>
				</div>
			</div>
		</div>
	);
};
